import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import { Container, Grid } from '@material-ui/core';
import Page from 'src/components/Page';
import Header from './Header';
import getAkses from 'src/utils/getAkses';
import PenjualanOverview from './PenjualanOverview';
import PembelianOverview from './PembelianOverview';
import LokasiChart from './LokasiChart';
import { logout } from 'src/actions';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  grid: {
    marginTop: theme.spacing(2)
  }
}));

function DashboardDefault() {
  const classes = useStyles();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const session = useSelector((state) => state.session);
  const dispatch = useDispatch();

  useEffect(() => {
    let mounted = true;
    const fetchData = () => {
      const authToken = {
        headers: { Authorization: `Bearer ${session.user.token}` }
      };
      axios
        .get('/user/dashboard', authToken)
        .then((response) => {
          if (mounted) {
            setData(response.data);
          }
        })
        .catch((error) => {
          console.error('Dashboard error:', error);
          if (error.response && error.response.status === 401) {
            dispatch(logout());
          } else {
            if (mounted) setError(error.message);
          }
        });
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, [session, dispatch]);

  if (error) {
    return (
      <Page className={classes.root} title="Default Dashboard">
        <Container maxWidth={false}>
          <Header />
          <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>
            <p>⚠ Gagal memuat data dashboard.</p>
            <small>{error}</small>
          </div>
        </Container>
      </Page>
    );
  }

  if (!data) {
    return (
      <Page className={classes.root} title="Default Dashboard">
        <Container maxWidth={false}>
          <Header />
          <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>
            <p>Memuat data...</p>
          </div>
        </Container>
      </Page>
    );
  }

  // Gabungkan "all" + per-lokasi untuk dirender
  const allCharts = [data.chart.all, ...(data.chart.lokasi || [])];

  return (
    <Page className={classes.root} title="Default Dashboard">
      <Container maxWidth={false}>
        <Header />
        {getAkses('dashboard', 1) && (
          <Grid container spacing={3} className={classes.grid}>
            {/* Summary Cards */}
            <Grid item lg={6} sm={6} xs={12}>
              <PenjualanOverview amount={data.now.penjualan} />
            </Grid>
            <Grid item lg={6} sm={6} xs={12}>
              <PembelianOverview amount={data.now.pembelian} />
            </Grid>

            {/* 4 Charts: Semua Lokasi + per lokasi */}
            {allCharts.map((item, index) => (
              <Grid item xs={12} key={index}>
                <LokasiChart
                  nama_lokasi={item.nama_lokasi}
                  penjualan={item.penjualan}
                  pembelian={item.pembelian}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Page>
  );
}

export default DashboardDefault;
